module.exports = __webpack_public_path__ + "img/js4.4287b1fc.jpg";